import React from 'react';
import './ProgressIndicator.css';

const ProgressIndicator = ({ progress }) => {
  return (
    <div className="progress-indicator-container">
      {/* First line segment: between dots 1 and 2 */}
      <div className="progress-line first-line">
        <div 
          className={`progress-line-filled ${progress >= 2 ? 'active' : ''}`}
        ></div>
      </div>
      
      {/* Second line segment: between dots 2 and 3 */}
      <div className="progress-line second-line">
        <div 
          className={`progress-line-filled ${progress >= 3 ? 'active' : ''}`}
        ></div>
      </div>
      
      <div className="dots-container">
        <div className="dot-column">
          <div className={`dot ${progress >= 1 ? 'active' : ''}`}></div>
        </div>
        <div className="dot-column">
          <div className={`dot ${progress >= 2 ? 'active' : ''}`}></div>
        </div>
        <div className="dot-column">
          <div className={`dot ${progress >= 3 ? 'active' : ''}`}></div>
        </div>
      </div>
      
      <div className="progress-labels">
        <div className="progress-label">
          <p>SIGN UP FOR</p>
          <p>OUR SMS LIST</p>
        </div>
        
        <div className="progress-label">
          <p>RECEIVE ALERTS</p>
          <p>FOR SHOWS</p>
        </div>
        
        <div className="progress-label">
          <p>TELL YOUR</p>
          <p>FRIENDS ABOUT IT</p>
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;